import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";
import Card from "../../components/Card";
import SalesChart from "../Dashboard/SalesChart";
import ProductTable from "./ProductTable";
import Modal from "components/Modal/Pawn/BuyProduct/ModalCreate"; // Import Modal component
import "../../assets/css/Dashbord.css"; // Corrected CSS file name to Dashboard.css
import { GradientButton } from "../../components/GradientButton";
import { useAuth } from "hooks/useAuth";
//Import Icon Mui
import InboxIcon from "@mui/icons-material/Inbox";
import OutboxIcon from "@mui/icons-material/Outbox";
import TrendingUpIcon from "@mui/icons-material/TrendingUp"; // Import TrendingUpIcon
import api from "_api";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [dateRange, setDateRange] = useState("week");
  const [isModalOpen, setModalOpen] = useState(false); // State for modal open
  const [fetchData, setFetchData] = useState({});

  const navigate = useNavigate();

  const handleDateRangeChange = (event) => {
    setDateRange(event.target.value);
  };
  // Request the USB device using WebUSB API
  // const device = await navigator?.usb?.requestDevice({
  //   filters: [{ vendorId: 0x04e6, productId: 0x5810 }],
  // });
  // console.log("Auth", useAuth());
  const fetchDashboardData = async () => {
    try {
      const { data } = await api.product.getDashboard();
      setFetchData(data);
    } catch (err) {
      console.error("error:", err);
    }
  };
  useEffect(() => {
    fetchDashboardData();
  }, []);
  useEffect(() => {
    console.log(fetchData);
  }, [fetchData]);
  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };
  // Send device details to the backend
  // setStatus("Sending device details to the server...");
  // const result = await api.pawn.connectUsbDevice({
  //   vendorId: device?.vendorId,
  //   productId: device?.productId,
  // });

  const firstMockup = [
    { title: "เงินต้น", value: "220,000", info: true },
    { title: "ยอดเงินคงเหลือ", value: "350,000", info: true },
  ];

  const secondMockup = [
    { title: "กำไรจากดอกเบี้ย", value: "5,000", info: true },
    { title: "กำไรจากการขาย", value: "20,000", info: true },
    { title: "จำนวนสินค้าที่ขายสะสม", value: "40", info: true },
    { title: "ต้นทุนสินค้าในสต็อก", value: "550,070", info: true },
  ];

  const thirdMockup = [
    {
      title: "รายรับ",
      value: "5,000",
      icon: <InboxIcon />,
      color: "1",
      info: true,
    },
    {
      title: "รายจ่าย",
      value: "20,000",
      icon: <OutboxIcon />,
      color: "2",
      info: true,
    },
    {
      title: "กำไร",
      value: "40",
      icon: <TrendingUpIcon />,
      color: "3",
      info: true,
    }, // Updated icon to TrendingUpIcon
  ];

  const productRows = [
    {
      รูปภาพ: "สินค้า 1",
      ทะเบียนรถ: "สินค้า 1",
      วันเพิ่ม: "12 กุมภาพันธ์ 2567",
    },
    {
      รูปภาพ: "สินค้า 2",
      ทะเบียนรถ: "สินค้า 1",
      วันเพิ่ม: "12 กุมภาพันธ์ 2567",
    },
    {
      รูปภาพ: "สินค้า 3",
      ทะเบียนรถ: "สินค้า 1",
      วันเพิ่ม: "12 กุมภาพันธ์ 2567",
    },
    {
      รูปภาพ: "สินค้า 4",
      ทะเบียนรถ: "สินค้า 1",
      วันเพิ่ม: "12 กุมภาพันธ์ 2567",
    },
    {
      รูปภาพ: "สินค้า 5",
      ทะเบียนรถ: "สินค้า 1",
      วันเพิ่ม: "12 กุมภาพันธ์ 2567",
    },
  ];

  const transactionRows = [
    {
      รหัสรายการ: "TH6701011",
      ชื่อลูกค้า: "ชื่อ-นามสกุล",
      วันที่เวลา: "12/02/67 เวลา 19:00 น.",
      ประเภท: "ต่อดอก",
    },
    {
      รหัสรายการ: "TH6701012",
      ชื่อลูกค้า: "ชื่อ-นามสกุล",
      วันที่เวลา: "12/02/67 เวลา 19:00 น.",
      ประเภท: "ต่อดอก",
    },
    {
      รหัสรายการ: "TH6701013",
      ชื่อลูกค้า: "ชื่อ-นามสกุล",
      วันที่เวลา: "12/02/67 เวลา 19:00 น.",
      ประเภท: "ต่อดอก",
    },
    {
      รหัสรายการ: "TH6701014",
      ชื่อลูกค้า: "ชื่อ-นามสกุล",
      วันที่เวลา: "12/02/67 เวลา 19:00 น.",
      ประเภท: "ต่อดอก",
    },
    {
      รหัสรายการ: "TH6701015",
      ชื่อลูกค้า: "ชื่อ-นามสกุล",
      วันที่เวลา: "12/02/67 เวลา 19:00 น.",
      ประเภท: "ต่อดอก",
    },
  ];

  return (
    <Container className="dashboard-container">
      <Typography variant="h4" className="dashboard-title">
        Dashboard
      </Typography>

      <Grid container spacing={2} style={{ marginTop: "20px" }}>
        {/* {firstMockup.map((metric, index) => ( */}
        <Grid item xs={12} sm={6} md={6}>
          <Card
            title="เงินต้ังต้น"
            value={fetchData?.companyBudget?.budget || 0}
            info="{metric.info}"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Card
            title="ยอดเงินคงเหลือ"
            value={fetchData?.companyBudget?.remaining_budget || 0}
            info="{metric.info}"
            className="card-item"
          />
        </Grid>
        {/* ))} */}
      </Grid>

      <RadioGroup
        row
        className="radio-group"
        value={dateRange}
        onChange={handleDateRangeChange}
      >
        <FormControlLabel value="day" control={<Radio />} label="วันนี้" />
        <FormControlLabel
          value="week"
          control={<Radio />}
          label="สัปดาห์นี้ (จันทร์-อาทิตย์)"
        />
        <FormControlLabel value="month" control={<Radio />} label="เดือนนี้" />
      </RadioGroup>

      <Grid
        container
        spacing={2}
        className="chart-container"
        style={{ marginTop: "20px" }}
      >
        <Grid item xs={12} sm={6} md={3}>
          <Card
            title="กำไรจากดอกเบี้ย"
            value={fetchData?.sumProfitFromInterest || 0}
            info="{metric.info}"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card
            title="กำไรจากการขาย"
            value={fetchData?.sumProfitFromSelling || 0}
            info="{metric.info}"
            className="card-item"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card
            title="จำนวนสินค้าที่ขายสะสม"
            value={fetchData?.sumSellingProductAmount || 0}
            info="{metric.info}"
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card
            title="ต้นทุนสินค้าในสต็อก"
            value={fetchData?.sumAllProductCostPrice || 0}
            info="{metric.info}"
            className="card-item"
          />
        </Grid>
      </Grid>

      <Grid
        container
        spacing={2}
        style={{ marginTop: "20px", height: "480px" }}
      >
        <Grid item xs={12} md={8} style={{ height: "100%" }}>
          <div className="chart-table" style={{ height: "100%" }}>
            <SalesChart logs={fetchData?.logs7Days} />
          </div>
        </Grid>
        <Grid item xs={12} md={4} style={{ height: "100%" }}>
          <Grid container spacing={2} style={{ height: "100%" }}>
            <Grid item xs={12}>
              <GradientButton onClick={handleModalOpen}>
                ดูกราฟทั้งหมด
              </GradientButton>
            </Grid>

            <Grid item xs={12}>
              <Card
                title="รายรับ"
                value={fetchData?.sumRevenue || 0}
                icon={<InboxIcon />}
                // info={metric.info}
                color="1"
                className="card-item"
              />
            </Grid>
            <Grid item xs={12}>
              <Card
                title="รายจ่าย"
                value={fetchData?.sumAllExpenditure || 0}
                icon={<OutboxIcon />}
                // info={metric.info}
                color="2"
                className="card-item"
              />
            </Grid>
            <Grid item xs={12}>
              <Card
                title="กำไร"
                value={fetchData?.totalProfit || 0}
                icon={<TrendingUpIcon />}
                // info={metric.info}
                color="3"
                className="card-item"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={2}
        className="table-container"
        style={{ marginTop: "20px" }}
      >
        <Grid item xs={12} md={6}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6" className="table-title">
              สินค้าล่าสุด
            </Typography>
            <GradientButton
              onClick={() => {
                // Handle click actions here
              }}
            >
              ดูสินค้าทั้งหมด
            </GradientButton>
          </Grid>

          <ProductTable rows={fetchData?.allProductsSort} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6" className="table-title">
              รายการล่าสุด
            </Typography>
            <GradientButton
              onClick={() => {
                navigate("/pawn/list_by_customer_pawn");
                // Handle click actions here
              }}
            >
              ดูรายการทั้งหมด
            </GradientButton>
          </Grid>
          {/* {fetchData?.allProductsSort?.length > 0 ? (
            <> */}
          <ProductTable rows={fetchData?.allOrderLog} />
          {/* <div>loadding</div> */}
          {/* </>
          ) : (
            <>
              <div>tes</div>
            </>
          )} */}
        </Grid>
      </Grid>

      <Modal open={isModalOpen} onClose={handleModalClose} />
    </Container>
  );
};

export default Dashboard;

//Frontend
// import React, { useState } from "react";
// import api from "_api";

// function ICReader() {
//   const [cardData, setCardData] = useState("");
//   const [status, setStatus] = useState("Ready to connect");

//   // Function to connect to the USB device
//   async function connectToDevice() {
//     try {
//       setStatus("Requesting device...");

//       // Request the USB device using WebUSB API
//       const device = await navigator.usb.requestDevice({
//         filters: [{ vendorId: 0x04e6, productId: 0x5810 }],
//       });

//       console.log("Device selected:", device);

//       // Send device details to the backend
//       setStatus("Sending device details to the server...");
//       const result = await api.pawn.connectUsbDevice({
//         vendorId: device.vendorId,
//         productId: device.productId,
//       });

//       if (result.isStatus) {
//         setCardData(result.data.cardData);
//         setStatus("Data received successfully");
//       } else {
//         setStatus(`Failed: ${result.message}`);
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       setStatus("Failed to connect or read card data");
//     }
//   }

//   return (
//     <div>
//       <h1>IC Reader</h1>
//       <p>Status: {status}</p>
//       <button onClick={connectToDevice}>Connect and Read</button>
//       {cardData && <pre>{JSON.stringify(cardData, null, 2)}</pre>}
//     </div>
//   );
// }

// export default ICReader;
